<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.workOrderTemplates'), $t('text.list')]"
      ></breadcrumb>
      <div class="container">
        <el-form
          ref="printTemplateForm"
          :model="printTemplate"
          label-width="80px"
          size="small"
        >
          <div class="pd20">
            <fieldset>
              <legend>{{ $t("text.baseInfo") }}</legend>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item
                    :label="$t('text.name')"
                    :prop="'name'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('text.name')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input size="small" v-model.trim="printTemplate.name" />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <el-row :gutter="20">
              <el-col :span="16">
                <fieldset class="mgb15">
                  <legend>{{ $t("text.template") }}</legend>
                  <tinymce-editor
                    ref="editor"
                    v-model="printTemplate.content"
                    :height="1300"
                    :menubar="true"
                  />
                </fieldset>
              </el-col>
              <el-col :span="8">
                <fieldset class="mgb15">
                  <legend>{{ $t("text.reference") }}</legend>
                  <vxe-table
                    :data="references"
                    row-id="id"
                    ref="recordsTable"
                    class="recordsTable"
                    size="mini"
                    resizable
                    round
                    border
                    highlight-hover-row
                    auto-resize
                    :scroll-y="{ enabled: false }"
                  >
                    <vxe-table-column
                      type="seq"
                      :title="$t('text.seq')"
                      width="50"
                    ></vxe-table-column>
                    <vxe-table-column field="name" :title="$t('text.name')" />
                    <vxe-table-column
                      field="value"
                      :title="$t('text.reference')"
                    />
                  </vxe-table>
                </fieldset>
              </el-col>
            </el-row>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import BackButton from "@/components/BackButton";
import TinymceEditor from "@/components/TinymceEditor";
import { referencesWorkOrder } from "@/utils/enums.js";
import PrintTemplate from "@/api/printTemplate.js";

export default {
  mixins: [page],
  components: { BackButton, TinymceEditor },
  data() {
    return {
      references: referencesWorkOrder,
      printTemplate: {
        name: null,
        content:
          "<div style='margin: 0px auto 10px; width: 650px; text-align: left;'>" +
          "<table style='border-collapse: collapse; width: 650px; height: 220px;' border='1'>" +
          "<tbody>" +
          "<tr style='height: 22px;'> " +
          "<td style='width: 57.3456%; height: 22px; text-align: center;' colspan='4'>简赢（上海）信息科技有限公司</td>" +
          "<td style='width: 28.6832%; height: 66px;' colspan='2' rowspan='3'>${工单号二维码}</td>" +
          "</tr>" +
          "<tr style='height: 22px;'>" +
          "<td style='width: 14.3364%; height: 22px;'>工单号</td>" +
          "<td style='width: 43.0092%; height: 22px;' colspan='3'>${工单号}</td>" +
          "</tr>" +
          "<tr style='height: 22px;'>" +
          "<td style='width: 14.3364%; height: 22px;'>客户/经办</td>" +
          "<td style='width: 43.0092%; height: 22px;' colspan='3'>${客户}/${经办人}-${经办部门}</td>" +
          "</tr>" +
          "<tr style='height: 22px;'>" +
          "<td style='width: 14.3364%; height: 22px;'>货号</td>" +
          "<td style='width: 14.6703%; height: 22px;'>${货号}</td>" +
          "<td style='width: 14.0025%; height: 22px;'>下单日期</td>" +
          "<td style='width: 14.3364%; height: 22px;'>${下单日期}</td>" +
          "<td style='width: 14.3364%; height: 22px;'>交货日期</td>" +
          "<td style='width: 14.3468%; height: 22px;'>${交货日期}</td>" +
          "</tr>" +
          "<tr style='height: 22px;'>" +
          "<td style='width: 14.3364%; height: 22px;'>颜色</td>" +
          "<td style='width: 14.6703%; height: 22px;'>${颜色}${颜色图片}</td>" +
          "<td style='width: 14.0025%; height: 22px;'>规格</td>" +
          "<td style='width: 14.3364%; height: 22px;'>${规格}</td>" +
          "<td style='width: 14.3364%; height: 22px;'>数量</td>" +
          "<td style='width: 14.3468%; height: 22px;'>${数量}</td>" +
          "</tr>" +
          "<tr style='height: 22px;'>" +
          "<td style='height: 22px; width: 43.0092%;' colspan='3'>${大图}</td>" +
          "<td style='height: 22px; width: 43.0196%;' colspan='3'>${大图2}</td>" +
          "</tr>" +
          "<tr style='height: 22px;'>" +
          "<td style='height: 22px; width: 86.0288%;' colspan='6'>${小图}</td>" +
          "</tr>" +
          "<tr style='height: 22px;'>" +
          "<td style='width: 14.3364%; height: 22px;'>自定义属性</td>" +
          "<td style='height: 22px; width: 71.6924%;' colspan='5'>${自定义属性}</td>" +
          "</tr>" +
          "<tr style='height: 22px;'>" +
          "<td style='width: 14.3364%; height: 22px;'>备注</td>" +
          "<td style='height: 22px; width: 71.6924%;' colspan='5'>${订单备注}</td>" +
          "</tr>" +
          "<tr style='height: 22px;'>" +
          "<td style='width: 14.3364%; height: 22px;'>制作工艺</td>" +
          "<td style='height: 22px; width: 71.6924%;' colspan='5'>${制作工艺}</td>" +
          "</tr>" +
          "</tbody>" +
          "</table>" +
          "</div>",
        type: "produce",
      },
      saveDoing: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    if (self.Permit.extendModels().includes("mms")) {
      self.references.push({ name: "订单用料", value: "${订单用料}" });
    }
  },
  methods: {
    saveSubmit() {
      const self = this;
      this.$refs.printTemplateForm.validate((valid) => {
        if (valid) {
          self.saveDoing = true;
          PrintTemplate.create(self.printTemplate).then(function (res) {
            self.saveDoing = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.$router.push({ name: "perferenceMesWorkOrderTemplates" });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>